import { Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';
import { action, observable, makeObservable } from 'mobx';
import { PzOAuthSource } from '../sources/pz-oauth-source';
import AffiliateHubLogger from '../util/affiliate-hub-logger';
import { Logger } from 'bernie-logger';

export class PzOAuthStore extends Store {
  public accessToken: string;
  public refreshToken: string;

  private readonly pzOAuthSource: PzOAuthSource;

  public constructor(pzOAuthSource: PzOAuthSource, state: SerializedData, logger: Logger) {
    super(state, logger);

    makeObservable(this, {
      accessToken: observable,
      refreshToken: observable,
      setTokens: action,
      fetchAccessToken: action,
      refetchAccesstoken: action,
    });

    this.pzOAuthSource = pzOAuthSource;
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this.pzOAuthSource, data.pzOAuthSource);
  }

  public setTokens(access: string, refresh: string): void {
    this.accessToken = access;
    this.refreshToken = refresh;
  }

  public async fetchAccessToken(
    authorizationCode: string,
    userEmail: string,
  ): Promise<{
    accessToken: string;
    refreshToken: string;
  }> {
    try {
      const response = await this.pzOAuthSource.getAccessToken(authorizationCode, userEmail);
      const { access_token, refresh_token } = response.body;
      this.setTokens(access_token, refresh_token);
    } catch (e) {
      // Source has done all the handling for us, at this point, we should be quite sure that errorCode and body should
      // be present in the exception thrown.

      this.getLogger().error('PZ_ACCESS_TOKEN_FETCH_FAILED', e);

      return Promise.reject(e);
    }

    return Promise.resolve({ accessToken: this.accessToken, refreshToken: this.refreshToken });
  }

  public async refetchAccesstoken(token: string, email: string): Promise<{ accessToken: string }> {
    try {
      const response = await this.pzOAuthSource.getNewAccessToken(token, email);
      const { access_token, refresh_token } = response.body;
      this.setTokens(access_token, refresh_token);
    } catch (e) {
      // Source has done all the handling for us, at this point, we should be quite sure that errorCode and body should
      // be present in the exception thrown.

      this.getLogger().error('PZ_ACCESS_TOKEN_REFETCH_FAILED', e);

      return Promise.reject(e);
    }

    return Promise.resolve({ accessToken: this.accessToken });
  }

  private getLogger(): AffiliateHubLogger {
    return this.logger as AffiliateHubLogger;
  }
}
